import classNames from 'classnames';
import type {
  WishlistEntity,
} from '@dinosave/core/types';
import Button from '@/ui/components/Button';
import Text from '@/ui/components/Text';

import styles from './WishlistLinkStatic.module.css';

type WishlistLinkStaticProps = {
  wishlist: Omit<
    WishlistEntity,
    'id' |
    'slug'
  >;
  className?: string;
}
const WishlistLinkStatic = (props: WishlistLinkStaticProps) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    wishlist,
    className,
    ...rest
  } = props;

  // ##########################################################################
  // CONSTANTS
  // ##########################################################################

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const wishlistLinkStaticClassName = classNames({
    [styles.wishlistLinkStatic]: true,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div
      {...rest}
      className={wishlistLinkStaticClassName}
    >
      <Button
        kind="ghost"
        color="secondary"
        className={styles.button}
      >
        {wishlist?.emoji && (
          <div className={styles.icon}>
            {wishlist.emoji}
          </div>
        )}

        <div className={styles.details}>
          <div className={styles.name}>
            <Text
              color="neutral-600"
              weight="600"
              serif
            >
              {wishlist?.name}
            </Text>
          </div>

          <div className={styles.items}>
            <Text
              color="neutral-500"
              weight="500"
            >
              {wishlist?.itemsCount}
            </Text>

            <div className={styles.count}>
              <Text
                color="neutral-500"
                weight="500"
              >
                &nbsp;items
              </Text>
            </div>
          </div>
        </div>
      </Button>

    </div>
  );
};

export default WishlistLinkStatic;
